export default __webpack_public_path__ + "static/media/github.d32ab49e.png";